import * as React from 'react';
import { SVGProps } from 'react';

const IconTopSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.104 3.81v7.294h-1V3.81L2.457 6.457 1.75 5.75l3.854-3.854L9.457 5.75l-.707.707-2.646-2.646Z" />
  </svg>
);
export default IconTopSizeXs;
